exports.localPorts = {
  "account": 9001,
  "boundarywaters": 9009,
  "camping": 9002,
  "campinglottery": 9031,
  "cart": 9003,
  "permit-dayuse": 9062,
  "commercial-operators": 9024,
  "communication": 9010,
  "csr": 9011,
  "developer-portal": 9040,
  "field-sales": 9012,
  "grandteton": 9035,
  "hunting-permit": 9060,
  "internal-account": 9016,
  "internal-boundarywaters": 9033,
  "internal-camping": 9017,
  "internal-campinglottery": 9032,
  "internal-permit-dayuse": 9063,
  "internal-ftm": 9018,
  "internal-grandteton": 9037,
  "internal-hunting-permit": 9061,
  "internal-inyonwhitney": 9026,
  "internal-land-permit": 9052,
  "internal-permit-seasons": 9057,
  "internal-lowerdeschutes": 9036,
  "internal-mtwhitney": 9054,
  "internal-navigation": 9029,
  "internal-parkpass": 9019,
  "internal-pass": 9020,
  "internal-permit": 9021,
  "internal-permit-issuance": 9055,
  "internal-permit-lottery": 9056,
  "internal-permit-wbe": 9065,
  "internal-pos": 9022,
  "internal-refunds": 9059,
  "internal-ticket": 9023,
  "internal-tree-permit": 9071,
  "internal-vehicle-permit": 9028,
  "inyonwhitney": 9025,
  "land-permit": 9051,
  "lottery": 9013,
  "lowerdeschutes": 9034,
  "mt-whitney": 9053,
  "navigation": 9000,
  "pass": 9004,
  "permit": 9005,
  "permit-wbe": 9064,
  "rating-review": 9069,
  "rentals": 9030,
  "reporting": 9015,
  "search": 9006,
  "shift-managemenet": 9058,
  "sitepass": 9014,
  "ticket": 9007,
  "tree-permit": 9070,
  "trip-planner": 9008,
  "vehicle-permit": 9027
}
